import { Component } from 'vue';

export const activeModal: {
    active: boolean;
    component?: Component;
    props?: {};
} = {
    active: false,
    component: undefined,
    props: {},
};

export const toggleModal = (component: Component, props?: object) => {
    if (activeModal.active && activeModal.component === component) {
        return hideModal();
    }

    activeModal.active = true;
    activeModal.component = component;
    activeModal.props = props;
};

export const hideModal = () => {
    activeModal.active = false;
    activeModal.component = undefined;
    activeModal.props = {};
};
